export const returnValidImages = async (imageUrls: string[]) => {
  const promises = imageUrls.map(
    (url) =>
      new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(url);
        img.onerror = () => resolve(null);
      }),
  );

  const images = await Promise.all(promises);

  return images.filter((url) => url !== null) as string[];
};
